import { render, staticRenderFns } from "./OnlineList.vue?vue&type=template&id=45a6d304"
import script from "./OnlineList.vue?vue&type=script&lang=js"
export * from "./OnlineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports